export { default as Badge } from './Badge';
export type { BadgeProps, BadgeVariant } from './Badge';
